import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { CustomThemeProvider } from "./theme/CustomThemeProvider";

import AdminLayout from "./components/admin/AdminLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./components/NotFound";
import AdminLogin from "./components/Login";

// Admin pages
import AdminLanding from "./components/admin/AdminLanding";
import AdminDashboard from "./components/admin/AdminDashboard";
import AddAdmin from "./components/admin/AddAdmin";
import AddRecipe from "./components/admin/AddRecipe";
import UpdateRecipe from "./components/admin/UpdateRecipe";
import AddProduct from "./components/admin/AddProduct";
import UpdateProduct from "./components/admin/UpdateProduct";
import AddGenericProduct from "./components/admin/AddGenericProduct";
import UpdateGenericProduct from "./components/admin/UpdateGenericProduct";
import AddVariant from "./components/admin/AddVariant";
import UpdateVariant from "./components/admin/UpdateVariant";
import ProductManager from "./components/admin/ProductManager";
import AdminUsersStats from "./components/admin/AdminUsersStats";
import AdminFeedback from "./components/admin/AdminFeedback.jsx";
import AdminAnalyticsFunnel from "./components/admin/AdminAnalyticsFunnel.jsx";

const App = () => {
  return (
    <CustomThemeProvider>
      <Routes>
        {/* ✅ Landing */}
        <Route path="/" element={<AdminLanding />} />

        {/* ✅ Login */}
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* ✅ Admin area */}
        <Route path="/admin" element={<AdminLayout />}>
          {/* /admin -> /admin/dashboard */}
          <Route index element={<Navigate to="dashboard" replace />} />

          <Route
            path="dashboard"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="add-admin"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AddAdmin />
              </ProtectedRoute>
            }
          />

          <Route
            path="add-recipe"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AddRecipe />
              </ProtectedRoute>
            }
          />

          <Route
            path="update-recipe/:id"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <UpdateRecipe />
              </ProtectedRoute>
            }
          />

          <Route
            path="add-product"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AddProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="update-product"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <UpdateProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="add-generic-product"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AddGenericProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="update-generic-product"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <UpdateGenericProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="add-variant-product"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AddVariant />
              </ProtectedRoute>
            }
          />

          <Route
            path="update-variant-product"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <UpdateVariant />
              </ProtectedRoute>
            }
          />

          <Route
            path="products"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ProductManager />
              </ProtectedRoute>
            }
          />

          <Route
            path="users-stats"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminUsersStats />
              </ProtectedRoute>
            }
          />

          <Route
            path="feedback"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminFeedback />
              </ProtectedRoute>
            }
          />

          <Route
            path="analytics-funnel"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminAnalyticsFunnel />
              </ProtectedRoute>
            }
          />

          {/* admin not found */}
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* ✅ Ό,τι λάθος -> login */}
        <Route path="*" element={<Navigate to="/admin-login" replace />} />
      </Routes>
    </CustomThemeProvider>
  );
};

export default App;
